/* eslint-disable */
// @ts-nocheck
import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ViewChild } from '@angular/core'
import { MasterKey } from '../../../models/master-key'
import { Subject } from 'rxjs'
import { MasterKeyService } from '../../../services/master-key.service'
import { takeUntil } from 'rxjs/operators'
import { KeyNodeType } from '@overtur-monorepo/keying-shared'
// import { KeyingStructureService } from '../../../../apps/key-com/src/app/services/keying-structure.service'
// import { KeyingStructureService } from '../../../services/keying.structure.service'

@Component({
    selector: 'lib-master-key-tree',
    templateUrl: './master-key-tree.component.html',
    styleUrls: ['../menu-item/menu-item.component.scss'],
    standalone: false
})
export class MasterKeyTreeComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()
  keyNodeType = KeyNodeType

  @Input() hierarchyItem: MasterKey
  @Input() keySystem
  @Input() crossKeyHierarchy = false
  @Input() ownOperatingKey = false
  @Input() isResidentialSystem = false
  @Input() lastChild = true
  @Input() showChangeKeys = true
  @Input() showUnassignedKeys
  @Input() showNoKeysMessage

  @Output() selectKey = new EventEmitter<MasterKey>()
  @Output() deleteItemAction = new EventEmitter<MasterKey>()
  @Output() deleteChildrenAction = new EventEmitter<any>()
  @Output() patchItemAction = new EventEmitter<any>()
  @Output() addChildAction = new EventEmitter<MasterKey>()

  @ViewChild('actions') public actions

  selectedMasterKey: MasterKey
  isDisplay = false
  thruNode: MasterKey
  keyNodeType = KeyNodeType
  constructor(private masterKeyService: MasterKeyService) {}
  // private speccyService: SpeccyService,
  // private coreSettings: CoreSettings,
  // private dialogService: DialogService,

   /*istanbul ignore next*/
  ngOnInit() {
    if (this.crossKeyHierarchy && this.hierarchyItem.checked) {
      this.makeParentIndeterminate(this.hierarchyItem)
      // if (this.hierarchyItem.isMasterOperator) {
      //   this.isExpanded = false;
      // }
    }

    this.masterKeyService.selectedMasterKey$.pipe(takeUntil(this.destroy$)).subscribe((masterKey: MasterKey) => {
      if (!masterKey) {
        return
      }
      this.selectedMasterKey = masterKey
    })
  }

  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  disabled(hierarchyItem) {
    if (hierarchyItem.masterKeyTypeId === this.keyNodeType.ControlKey) {
      return true
    } else if (
      hierarchyItem.masterKeyTypeId === this.keyNodeType.ChangeKeyThruNode ||
      hierarchyItem.masterKeyTypeId === this.keyNodeType.SingleKeyDifferentThruNode
    ) {
      return true
    } else if (hierarchyItem.parent && hierarchyItem.parent.masterKeyTypeId === this.keyNodeType.CrossKeyChild) {
      return true
    } else if (hierarchyItem.isAssigned) {
      return false
    } else if (hierarchyItem.masterKeyTypeId === this.keyNodeType.CrossKeyChild) {
      return false
    } else {
      return true
    }
  }

  mouseEnter() {
    this.isDisplay = true
  }

  mouseLeave() {
    this.isDisplay = false
  }

  disableExpand() {
    const noChildren = !this.hierarchyItem.children || this.hierarchyItem.children.length === 0
    return this.hierarchyItem.isMasterOperator || noChildren
  }

  selectMasterKey(masterKey: MasterKey) {
    if (!this.disabled(masterKey)) {
      this.selectKey.emit(masterKey)
    }
  }

  descriptionChanged(updateMasterKeys = false) {}

  addChild(data): void {
    this.addChildAction.emit(data)
  }

  patchItem(patchData) {
    this.patchItemAction.emit(patchData)
  }

  deleteItem(hierarchyItem): void {
    this.deleteItemAction.emit(hierarchyItem)
  }

  deleteChildren(deleteData) {
    this.deleteChildrenAction.emit(deleteData)
  }

  toggleCrossKeySelection(val: boolean): void {
    if (val) {
      this.masterKeyService.selectMasterKey(this.hierarchyItem)
      this.makeParentIndeterminate(this.hierarchyItem)
    } else {
      this.hierarchyItem.isMasterOperator = false
      this.hierarchyItem.directChangesOperate = false
      this.removeMasterOperator(this.hierarchyItem)
      this.masterKeyService.deSelectMasterKey(this.hierarchyItem)
    }
  }

  makeParentIndeterminate(master: MasterKey) {
    if (!master.parent || master.parent.directChangesOperate) {
      return
    }
    master.parent.indeterminateCheckBox = true
    master.parent.disabledCheckBox = true
    this.makeParentIndeterminate(master.parent)
  }

  undoParentIndeterminate(master: MasterKey) {
    if (!master.parent) {
      return
    }
    let canMakeIndeterminate = true
    // parent must remain indeterminate if any of its children
    for (const child of master.parent.children) {
      if (child.checked) {
        canMakeIndeterminate = false
        break
      }
    }
    if (!canMakeIndeterminate) {
      return
    }
    master.parent.indeterminateCheckBox = false
    master.parent.disabledCheckBox = false
    this.undoParentIndeterminate(master.parent)
  }

  toggleMasterOperator(): void {
    this.hierarchyItem.isMasterOperator ? this.removeMasterOperator(this.hierarchyItem) : this.makeMasterOperator()
  }

  makeMasterOperator(): void {
    this.hierarchyItem.isMasterOperator = true
    this.hierarchyItem.indeterminateCheckBox = false
    if (this.hierarchyItem.directChangesOperate) {
      this.removeDirectChangesOperate()
    }
    this.makeParentIndeterminate(this.hierarchyItem)

    // // if not already checked, check the item and add to list in service
    if (!this.hierarchyItem.checked) {
      this.hierarchyItem.checked = true
      this.masterKeyService.selectMasterKey(this.hierarchyItem)
    }
    // // children are implicit - they are collapsed but need to uncheck them if they had previously selected
    for (const child of this.hierarchyItem.children) {
      if (child.isMasterOperator) {
        this.removeMasterOperator(child)
      }
      if (child.checked) {
        this.masterKeyService.deSelectMasterKey(child)
      }
    }
  }

  removeMasterOperator(item: MasterKey): void {
    item.isMasterOperator = false
    this.undoParentIndeterminate(item)
    item.children.forEach((child) => {
      child.disabledCheckBox = false
    })
  }

  toggleDirectChangesOperate(): void {
    this.hierarchyItem.directChangesOperate ? this.removeDirectChangesOperate() : this.applyDirectChangesOperate()
  }

  applyDirectChangesOperate(): void {
    this.hierarchyItem.directChangesOperate = true
    this.hierarchyItem.indeterminateCheckBox = false
    this.makeParentIndeterminate(this.hierarchyItem)

    // if not already checked, check the item and add to list in service
    if (!this.hierarchyItem.checked) {
      this.hierarchyItem.checked = true
      this.masterKeyService.selectMasterKey(this.hierarchyItem)
    }

    const changeKeys = this.hierarchyItem.children.filter((c) => c.isChangeKey)
    for (const changeKey of changeKeys) {
      changeKey.checked = true
      changeKey.disabledCheckBox = true
    }
  }

  removeDirectChangesOperate(): void {
    this.hierarchyItem.directChangesOperate = false
    this.hierarchyItem.indeterminateCheckBox = false
    this.undoParentIndeterminate(this.hierarchyItem)

    const changeKeys = this.hierarchyItem.children.filter((c) => c.isChangeKey)
    for (const changeKey of changeKeys) {
      changeKey.checked = false
      changeKey.disabledCheckBox = false
    }
  }

  hasMinimize(hierarchyItem) {
    if (
      hierarchyItem?.children?.length &&
      !hierarchyItem.isChangeKey &&
      (hierarchyItem.children.length !== hierarchyItem.changeKeys.length || this.showChangeKeys)
    ) {
      return true
    } else {
      return false
    }
  }
}
